import getSelectOptions from './select-options';

class FieldProcessor {

    constructor() {
    }

    getDefaultParams() {
        return {
            passedSteps: [],
            _material: this.getSelectOptions('materialMm')[0],
            _offset: this.getSelectOptions('offset')[0],
            mesh: undefined,
            fileName: undefined,
            orientType: this.getSelectOptions('_orientType')[0],
            _thickness:" 0.8",
            lockOffset: false,
            _holdingCond: '0.0',
            _results: 'thinning',
            materialCost: 1000,
            // calculatedWidth: 0,
            _width: 0,
            _convex: 0,
            _smooth: 0,
            priceUnit: this.getSelectOptions('priceUnit')[0],
            nType: this.getSelectOptions('nType')[0],
            _selectedReportView: this.getSelectOptions('selectedReportView')[0],
            coilMargin: 0,
            bridgeSpan: 0,
            addWidth: 0,
            customWidth: undefined,
            isUsedCustomWidth: undefined,
            scrapVal: 200,
            partsNumber: 10000,
            meshView: undefined,
            nestN2: undefined,
            meshLL: undefined,
            boundary: undefined,
            blankBoundaryMod: undefined,
            blankBoundaryModCustom: undefined,
            afeb: undefined,
            _unit: this.getSelectOptions('unit')[0],
            formabilityView: undefined,
            thinningView: undefined,
            blankView: undefined,
            nestView: undefined,
            snapshots: [],
            position: {},
            // userLastName: '',
            utilizationInfo: 0,
            cashedSim: {},
            cashedSimViews: {},
      // expirationTime: undefined
        }
    }

    getSelectOptions(key) {
        return getSelectOptions()[key];
    }

    getAllKeys() {
        return Object.keys(this.getDefaultParams());
    }


    getAllUIKeys() {
        return {
            part: [
                'mesh',
                'fileName',
                '_holdingCond',
                'cashedSim',
                '_thickness',
                '_material',
                'unit',
                '_unit',
                '_offset',
                'lockOffset',
                'maxDimensions',
                'meshView',
                'passedSteps'
            ], nest: [
                '_thickness',
                'material',
                'nType',
                'unit',
                '_unit',
                'coilMargin',
                'bridgeSpan',
                'orientType',
                'orientAngle',
                'materialCost',
                'priceUnit',
                'scrapVal',
                'addWidth',
                '_unit',
            ], blank: [
                // 'width',
                'isUsedCustomWidth',
                '_width',
                'thinningView',
                'formabilityView',
                // 'convex',
                '_convex',
                // 'smooth',

                'customWidth',
                'addWidth',
                'snapshots',
                '_smooth',
                'unit',
                'afeb',
                '_unit',
                'meshLL',
                'mex',
                'boundary',
                'blankBoundaryMod',
                'blankBoundaryModCustom',
                'blankView',
            ], clear: []
        };
    }

    getStepValues() {
        return {
            feasibility: [
                'fileName',
                'holdingCond',
                'thickness',
                'material',
                'offset',
            ], blank: [
                'convex',
                'smooth',
                'holdingCond',
                'customWidth',
                'addWidth',
                '_unit'
            ], nest: [
                'isUsedCustomWidth',
                'width',
                'results',
                'holdingCond',
                'calculatedWidth',
                'smooth',
                'convex',
                'thickness',
                'material',
                'nType',
                'coilMargin',
                'bridgeSpan',
                'orientType',
                'orientAngle',
                'materialCost',
                'priceUnit',
                'scrapVal',
                'addWidth',
                '_unit'
            ], clear: []
        };
    }

    getInvalidatedKeys(key) {
        const mapper = {
            part: [
                'meshFile',
                'fileName',
                'mesh',
                'material',
                'offset',
                'unit',
                '_unit',
                'boundaries',
                'thickness',
                '_thickness',
            ],
            feasiblity: [
              'holdingCond',
            ]
        }
        return mapper[key];
    }

    getUIKeysByStep(step) {
        return this.getAllUIKeys()[step];
    }

    getUnitFiels() {
        return ['_thickness', 'thickness', 'addWidth', 'bridgeSpan' , 'convex' , 'smooth', 'width'];
    }
}

export default FieldProcessor;



// WEBPACK FOOTER //
// ./client/app/common/services/field-processor.js